import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { toJpeg } from 'html-to-image';
import { PageCertificate } from '@scormhero/shared';

import styles from './CertificateModal.module.scss';
import Label from '../../context/Label/Label';
import ButtonAlt from '../../UI/ButtonAlt/ButtonAlt';
import CertificateItself from './CertificateItself';

type CertificateModalProps = PageCertificate & {
  onClickOutside: () => void;
  globalState: any;
};

function CertificateModal({ onClickOutside, ...props }: CertificateModalProps) {
  const { player } = props.globalState;
  const [certificateDiv, setCertificateDiv] = useState<HTMLDivElement | null>(
    null
  );
  const [printDialogOpen, setPrintDialogOpen] = useState<boolean>(false);

  async function handleDownload() {
    if (!certificateDiv) return;
    toJpeg(certificateDiv, { quality: 0.95 }).then((dataUrl) => {
      const link = document.createElement('a');
      link.download = `certificate.jpeg`;
      link.href = dataUrl;
      link.click();
    });
  }

  function handlePrint() {
    setPrintDialogOpen(true);
    // why this? because this state do allow print from editMode
    setTimeout(() => {
      window.print();
      setPrintDialogOpen(false);
    }, 1000);
  }

  return (
    <ReactModal
      isOpen={true}
      onRequestClose={onClickOutside}
      overlayClassName={
        player?.editMode && printDialogOpen
          ? styles.modalOverlayPrintDialogOpen
          : undefined
      }
      className={
        !player?.editMode || printDialogOpen
          ? styles.modalContent
          : styles.modalContentInEditMode
      }
      ariaHideApp={false}
    >
      <div className={styles.topMenu}>
        {certificateDiv && (
          <ButtonAlt icon="download" onClick={handleDownload}>
            <Label>download</Label>
          </ButtonAlt>
        )}
        <ButtonAlt
          icon="print"
          onClick={handlePrint}
          disabled={printDialogOpen}
        >
          <Label>print</Label>
        </ButtonAlt>
        <ButtonAlt icon="times" onClick={onClickOutside} />
      </div>
      <CertificateItself {...props} onMount={setCertificateDiv} />
    </ReactModal>
  );
}

export default CertificateModal;
